<div class="boletim-container" *ngIf="!carregando">
  <div class="boletim-header">
    <h3>Desempenho Escolar</h3>
  </div>

  <div class="table-wrapper" *ngIf="boletim">
    <table class="boletim-table">
      <thead>
        <tr>
          <th class="col-disciplina">DISCIPLINA</th>
          
          <!-- Periodos dinâmicos -->
          <ng-container *ngFor="let periodo of boletim.cabecalho.periodos">
            <th colspan="3" class="col-bimestre">{{ periodo.nome }}</th>
          </ng-container>
          <!-- Colunas finais -->
          <th colspan="4" class="col-resultado-final">Resultado Final</th>
        </tr>
        <tr>
          <th class="col-disciplina"></th>
          <!-- Cabeçalhos das colunas de cada período -->
          <ng-container *ngFor="let periodo of boletim.cabecalho.periodos">
            <ng-container *ngFor="let coluna of boletim.cabecalho.colunas">
              <th class="col-media" *ngIf="coluna === 'Média'">Média</th>
              <th class="col-faltas" *ngIf="coluna === 'Faltas'">Faltas</th>
              <th class="col-rel-bim" *ngIf="coluna === 'Rel.'">Rel.</th>
            </ng-container>
          </ng-container>
          <th class="col-ma">MA</th>
          <th class="col-tf">TF</th>
          <th class="col-rf">RF</th>
          <th class="col-relatorio">Relatório Anual</th>
        </tr>
      </thead>
      <tbody>

        <tr *ngFor="let disciplina of boletim.disciplinas">
  <td class="disciplina-nome">{{ disciplina.disciplina }}</td>

  <!-- Dados de cada período -->
  <ng-container *ngFor="let nota of disciplina.periodos; let i = index">
    <td class="nota">{{ nota.media }}</td>
    <td class="faltas">{{ nota.faltas }}</td>
    <td class="relatorio-bim-cell">
      <button
        class="btn-relatorio-bim"
        (click)="abrirRelatorioPeriodo(alunoId, i + 1, turmaId, disciplina.turmaDisciplinaId)"
        title="Ver relatório">
        <mat-icon>description</mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- Colunas finais -->
  <td class="media-anual">{{ disciplina.mediaAnual }}</td>
  <td class="total-faltas">{{ disciplina.totalFaltas }}</td>
  <td>
    <span class="resultado-final" [ngClass]="disciplina.resultadoFinal === 'Aprovado' ? 'aprovado' : disciplina.resultadoFinal === 'Reprovado' ? 'reprovado' : 'nao-definido'">
      <span *ngIf="disciplina.resultadoFinal === 'Aprovado'">APROVADO</span>
      <span *ngIf="disciplina.resultadoFinal === 'Reprovado'">REPROVADO</span>
      <span *ngIf="disciplina.resultadoFinal === 'NaoDefinido'">INDEFINIDO</span>
    </span>
  </td>
  <td class="relatorio-cell">
    <button class="btn-relatorio" (click)="abrirRelatorioPeriodo(alunoId, -1, turmaId, disciplina.turmaDisciplinaId)" title="Ver relatório anual">
      <mat-icon>description</mat-icon>
    </button>
  </td>
</tr>


      </tbody>
    </table>
  </div>

  <div class="no-data" *ngIf="!boletim">
    <p>Nenhum boletim disponível para este aluno e ano.</p>
  </div>
</div>

<div class="loading" *ngIf="carregando">
  <div class="spinner"></div>
  <p>Carregando boletim...</p>
</div>

